import { ArrowLeftRight } from 'lucide-react'
import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@lib/permissions/guards'
import MouvementsTab from '@features/stock/components/MouvementsTab'

export const Route = createFileRoute('/_app/stock/mouvements')({
  staticData: {
    title: 'Mouvements',
    icon: ArrowLeftRight,
    tab_icon: ArrowLeftRight,
    permission: 'stock.movements.view',
    module: 'stock',
    section: 'Stock',
    order: 48,
     showInTab: true,
     showInNav: true,
     showInBreadcrumb: true,
  },
  loader: requirePermission('stock.movements.view'),
  component: MouvementsTab,
})
